import { Component } from '@angular/core';

@Component({
  selector: 'app-landscape-mode',
  templateUrl: './landscape-mode.component.html',
  styleUrls: ['./landscape-mode.component.scss']
})
export class LandscapeModeComponent {}
